import { RootState } from '../store';
import { AuthState } from '../slices/auth';

export const authSelector: (state: RootState) => AuthState = (
  state: RootState,
) => state.auth;
